import{styled as t}from"@mui/material/styles";const i=t("div")(({theme:e})=>({height:"100%",'[class^="_TextContainer"]':{...e.typography.chart1,lineHeight:"1rem",fontSize:"0.75rem"},'[class^="_ChartContainer"]':{...e.typography.chart1},'button[class^="_Legend"]':{borderRadius:e.spacing(.75),padding:`${e.spacing(.75,1)} !important`,"& > span":{...e.typography.chipLabel}},'[class^="_Container"][data-tooltip]':{'[class^="_Title"]':{...e.typography.body1},'[class^="_Row"]':{...e.typography.body1}}})),o=e=>`
    ._Point_gkfp3_144 {
  outline: none;
  pointer-events: none;
}
._Point_gkfp3_144:focus, ._Point_gkfp3_144:focus-visible {
  outline: none !important;
}

._VisuallyHidden_gkfp3_152 {
  position: absolute !important;
  top: 0;
  clip: rect(1px, 1px, 1px, 1px) !important;
  overflow: hidden !important;
  height: 1px !important;
  width: 1px !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0;
}

._Crosshair_1t1jt_1 {
  pointer-events: none;
}

._Shimmer_hqp2w_1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: scale(5, 10);
  animation-name: _shimmer_hqp2w_1;
  animation-duration: 10s;
  /* stylelint-disable */
  animation-timing-function: linear;
  /* stylelint-enable */
  animation-iteration-count: infinite;
  background-size: calc(var(--shimmerWidth)*1) calc(var(--shimmerHeight)*1);
  background-position-y: 0;
  pointer-events: none;
}

@keyframes _shimmer_hqp2w_1 {
  0% {
    background-position-x: calc(var(--shimmerWidth)*1*-1);
  }
  50% {
    background-position-x: calc(var(--shimmerWidth)*1*2);
  }
  51% {
    background-position-x: calc(var(--shimmerWidth)*1*-1);
  }
  100% {
    background-position-x: calc(var(--shimmerWidth)*1*2);
  }
}

._Arc_12guq_144 {
  outline: none;
}
._Arc_12guq_144:focus, ._Arc_12guq_144:focus-visible {
  outline: none !important;
}

._Donut_1xk67_144 {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: visible;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  align-items: center;
}

._DonutWrapper_1xk67_154 {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

._ContentWrapper_1xk67_162 {
  position: absolute;
  justify-content: center;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  font-size: 20px;
  pointer-events: none;
  width: 100%;
  height: 100%;
}
._ContentWrapper_1xk67_162 span {
  max-width: 50%;
  text-align: center;
  color: white;
  font-size: 11px;
}

._DonutChart_1xk67_180 {
  outline: none;
  overflow: visible;
}
._DonutChart_1xk67_180:focus, ._DonutChart_1xk67_180:focus-visible {
  outline: none !important;
}

._Label_1vvi2_144 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

._SVG_186th_144 {
  display: block;
  font-feature-settings: normal;
  outline: none;
}
._SVG_186th_144:focus, ._SVG_186th_144:focus-visible {
  outline: none !important;
}

._Bar_1hwkw_144 {
  outline: none;
  transition: fill 300 ease;
}
._Bar_1hwkw_144:focus, ._Bar_1hwkw_144:focus-visible {
  outline: none !important;
}

@media print {
  ._Group_1hwkw_153 {
    transform: none !important;
  }
}

._Bar_h2fc5_144 {
  outline: none;
}
._Bar_h2fc5_144:focus, ._Bar_h2fc5_144:focus-visible {
  outline: none !important;
}

._Group_kzepq_144 {
  outline: none;
}
._Group_kzepq_144:focus, ._Group_kzepq_144:focus-visible {
  outline: none !important;
}

._SimpleBarSkeleton_1nscx_1 {
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
}

._Item_1nscx_8 {
  display: grid;
  grid-template-rows: 16px 40px;
  grid-template-columns: 20% auto;
  gap: 20px;
}
._Item_1nscx_8 > *:last-child {
  grid-column: span 2;
}

._Container_7i430_1 {
  display: flex;
}

._Legend_7i430_5 {
  height: 50px;
  display: flex;
  gap: 5%;
  max-width: 60%;
  margin: 14px 0;
}

._LegendItem_7i430_13 {
  width: 100%;
  display: block;
  display: grid;
  grid-template-columns: 16px 1fr;
  grid-template-rows: 16px;
  grid-gap: 10px;
}
._LegendItem_7i430_13 > *:first-of-type {
  width: 16px;
  height: 16px;
}
._LegendItem_7i430_13 > *:nth-of-type(2) {
  height: 16px;
}
._LegendItem_7i430_13 > *:nth-of-type(3) {
  grid-column: 2;
  height: 16px;
  width: 80%;
}

._LegendItemComponent_7i430_34 {
  border-radius: 2px;
  height: 16px;
  width: 100%;
}

._Container_1ymq9_1 {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

._ChartContainer_yw85c_144 {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: Inter, -apple-system, "system-ui", "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
  font-size: 12px;
}
._ChartContainer_yw85c_144 *:focus, ._ChartContainer_yw85c_144 *:focus-visible {
  outline: 2px solid #4b92e5;
  outline-offset: 2px;
}

._ContainerBounds_yw85c_157 {
  height: 100%;
  width: 100%;
}

._Chart_yw85c_144 {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
._Chart_yw85c_144 svg {
  overflow: visible;
  max-width: 100%;
}

._VisuallyHidden_1laex_144 {
  position: absolute !important;
  top: 0;
  clip: rect(1px, 1px, 1px, 1px) !important;
  overflow: hidden !important;
  height: 1px !important;
  width: 1px !important;
  padding: 0 !important;
  border: 0 !important;
}

._VisuallyHidden_12uto_144 {
  position: absolute !important;
  top: 0;
  clip: rect(1px, 1px, 1px, 1px) !important;
  overflow: hidden !important;
  height: 1px !important;
  width: 1px !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0;
}

._ComparisonLine_12uto_156 {
  stroke-linecap: round;
}

._SkipLink_1jwcn_1 {
  position: absolute;
  top: 1px;
  left: 1px;
  background: white;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.05);
  border-radius: 0.4rem;
  color: #212b36;
  border: 1px solid #babfc3;
  padding: 8px 16px;
  opacity: 0;
  pointer-events: none;
  text-decoration: none;
}
._SkipLink_1jwcn_1:focus {
  pointer-events: all;
  opacity: 1;
}

._Line_y7hzj_1 {
  pointer-events: none;
}

._Blur_m9tly_1 {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

._Button_m9tly_9 {
  border: 0;
  background: transparent;
  height: 100%;
  width: 100%;
  font-size: 0;
  display: block;
}

._Container_195be_1 {
  pointer-events: auto;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  padding: 8px 12px;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
}

._Title_195be_9 {
  font-weight: 500;
  line-height: 20px;
  font-size: 12px;
  margin: 0 0 4px;
}

._Content_195be_16 {
  font-size: 11px;
  line-height: 16px;
  margin: 0;
}

._Link_195be_22 {
  margin-left: 4px;
}

._Button_pb42n_1 {
  border: 0;
  background: transparent;
  height: 100%;
  width: 100%;
  font-size: 0;
  display: block;
}

._Group_kzepq_144 {
  outline: none;
}
._Group_kzepq_144:focus, ._Group_kzepq_144:focus-visible {
  outline: none !important;
}

._Container_8b5v1_1 {
  display: flex;
}

._SVG_8b5v1_5 {
  display: block;
  overflow: visible;
}

._ColorPreview_1wdtl_144 {
  border-radius: 100%;
  display: block;
  flex: none;
  -webkit-print-color-adjust: exact;
  /* stylelint-disable-line property-no-vendor-prefix */
  print-color-adjust: exact;
  /* stylelint-disable-line property-no-unknown */
  overflow: hidden;
}

._Legend_spsas_144 {
  padding: 6px 0;
  outline: none;
  border: none;
  border-radius: 2px;
  display: flex;
}
._Legend_spsas_144:focus, ._Legend_spsas_144:focus-visible {
  outline: 2px solid #4b92e5;
  outline-offset: 2px;
}
._Legend_spsas_144:focus {
  outline: none;
}
._Legend_spsas_144:focus-visible {
  outline: 2px solid #4b92e5;
  outline-offset: 2px;
}

._TextContainer_spsas_163 {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 3px;
  line-height: 16px;
  margin: -2px 0;
  font-family: Inter, -apple-system, "system-ui", "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
  white-space: nowrap;
  min-width: 0;
}

._Text_spsas_163 {
  overflow: hidden;
  text-overflow: ellipsis;
}

._IconContainer_spsas_180 {
  display: flex;
  align-items: center;
  justify-content: center;
}

._Container_ijalm_1 {
  display: flex;
  gap: 10px;
}

._ChartContainer_11yon_144 {
  position: relative;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

._SVG_11yon_154 {
  overflow: visible;
  max-width: 100%;
  min-width: 0;
}
._SVG_11yon_154 [data-color-vision-event-watch=true] {
  outline: none;
}
._SVG_11yon_154 [data-color-vision-event-watch=true]:focus, ._SVG_11yon_154 [data-color-vision-event-watch=true]:focus-visible {
  outline: none !important;
}

._Bar_1w2vx_144 {
  outline: none;
  transition: fill 300 ease;
}
._Bar_1w2vx_144:focus, ._Bar_1w2vx_144:focus-visible {
  outline: none !important;
}

._BarGroup_1gnzm_144,
._Bar_1gnzm_144 {
  outline: none;
}
._BarGroup_1gnzm_144:focus, ._BarGroup_1gnzm_144:focus-visible,
._Bar_1gnzm_144:focus,
._Bar_1gnzm_144:focus-visible {
  outline: none !important;
}

._Bar_h2fc5_144 {
  outline: none;
}
._Bar_h2fc5_144:focus, ._Bar_h2fc5_144:focus-visible {
  outline: none !important;
}

._Group_kzepq_144 {
  outline: none;
}
._Group_kzepq_144:focus, ._Group_kzepq_144:focus-visible {
  outline: none !important;
}

._Container_1op8q_1 {
  position: absolute;
  pointer-events: none;
  z-index: 520;
  max-width: 70%;
}

._MoreText_kibmg_1 {
  display: flex;
  white-space: nowrap;
  align-items: center;
  background: none;
  border: none;
  border-radius: 2px;
  font-size: 11px;
}

._Tooltip_kibmg_11 {
  position: absolute;
  display: flex;
  flex-direction: column;
  padding: 4px;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  border-radius: 5px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2), 0 2px 10px rgba(0, 0, 0, 0.1);
}

._VisuallyHidden_at2zh_144 {
  position: absolute !important;
  top: 0;
  clip: rect(1px, 1px, 1px, 1px) !important;
  overflow: hidden !important;
  height: 1px !important;
  width: 1px !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0;
}

._Container_mnywe_1 {
  position: relative;
  display: flex;
  align-items: baseline;
  width: 100%;
}

._ContainerDefaultLabel_mnywe_8 {
  margin-bottom: 32px;
}

._ContaineBottomLabel_mnywe_12 {
  margin-top: 20px;
}

._LabelColor_mnywe_16 {
  margin: 1px;
  border-radius: 3px;
  height: 10px;
  width: 10px;
}

._Label_mnywe_16 {
  flex: 1 1;
  margin: 0 8px;
  word-break: break-word;
  max-width: 120px;
  line-height: 18px;
}

._FormattedVerticalLabel_mnywe_31 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  white-space: normal;
}

._FormattedHorizontalLabel_mnywe_39 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

._ValueContainer_mnywe_45 {
  margin-top: 4px;
  display: flex;
}

._ValueHorizontalContainer_mnywe_50 {
  position: absolute;
  top: 16px;
  margin-top: 4px;
  display: flex;
  align-items: center;
}

._Value_mnywe_45 {
  margin-right: 8px;
  font-weight: 650;
}

._Segment_7hgfv_144 {
  outline: none;
  margin: 1px 2px 2px 1px;
}
._Segment_7hgfv_144:focus, ._Segment_7hgfv_144:focus-visible {
  outline: none !important;
}
._Segment_7hgfv_144:last-of-type {
  margin: 1px;
}

._horizontal-RoundedCorners_7hgfv_155:first-of-type {
  border-radius: 2px 0 0 2px;
}
._horizontal-RoundedCorners_7hgfv_155:last-of-type {
  border-radius: 0 2px 2px 0;
}

._vertical-RoundedCorners_7hgfv_162:first-of-type {
  border-radius: 0 0 2px 2px;
}
._vertical-RoundedCorners_7hgfv_162:last-of-type {
  border-radius: 2px 2px 0 0;
}

._RoundedCorners_7hgfv_169 {
  border-radius: 2px;
}

._horizontal-small_7hgfv_173 {
  height: 16px;
}

._horizontal-medium_7hgfv_177 {
  height: 36px;
}

._horizontal-large_7hgfv_181 {
  height: 56px;
}

._vertical-small_7hgfv_185 {
  width: 16px;
}

._vertical-medium_7hgfv_189 {
  width: 36px;
}

._vertical-large_7hgfv_193 {
  width: 56px;
}

._Container_pgxim_144 {
  font-family: Inter, -apple-system, "system-ui", "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
  font-size: 11px;
  display: flex;
  box-sizing: border-box;
  -webkit-print-color-adjust: exact;
  /* stylelint-disable-line property-no-vendor-prefix */
  print-color-adjust: exact;
  /* stylelint-disable-line property-no-unknown */
}

._VerticalContainer_pgxim_155 {
  height: 100%;
}

._VerticalContainerRightLabel_pgxim_159 {
  flex-direction: row-reverse;
  justify-content: flex-end;
}

._HorizontalContainer_pgxim_164 {
  flex-direction: column;
  justify-content: normal;
}

._HorizontalContainerBottomLabel_pgxim_169 {
  flex-direction: column-reverse;
}

._BarContainer_pgxim_173 {
  display: flex;
}

._VerticalBarContainer_pgxim_177 {
  flex-direction: column-reverse;
}

._HorizontalBarContainer_pgxim_181 {
  flex-direction: row;
}

._VerticalLabelContainer_pgxim_185 {
  margin: 0 20px;
  padding: 0;
}

._HorizontalLabelContainer_pgxim_190 {
  padding: 0;
  display: flex;
}

._HorizontalLabelContainerGrid_pgxim_195 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, max-content));
}

._LabelContainerEndJustify_pgxim_200 {
  justify-content: end;
  justify-items: end;
}

._ColorPreview_t4h1x_144 {
  border-radius: 2px;
  display: block;
  flex: none;
  -webkit-print-color-adjust: exact;
  /* stylelint-disable-line property-no-vendor-prefix */
  print-color-adjust: exact;
  /* stylelint-disable-line property-no-unknown */
}

._Group_kzepq_144 {
  outline: none;
}
._Group_kzepq_144:focus, ._Group_kzepq_144:focus-visible {
  outline: none !important;
}

@media print {
  ._Group_oqjz6_2 {
    -webkit-clip-path: none;
            clip-path: none;
  }
}

._Donut_1ga5u_144 {
  position: relative;
  display: flex;
  overflow: visible;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  align-items: center;
}

._DonutWrapper_1ga5u_152 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

._ContentWrapper_1ga5u_160 {
  position: absolute;
  justify-content: center;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  pointer-events: none;
  width: 100%;
  height: 100%;
}

._ContentValue_1ga5u_171 {
  line-height: 24px;
  font-weight: 700;
  -webkit-user-select: text;
     -moz-user-select: text;
      -ms-user-select: text;
          user-select: text;
  margin: 0;
  font-variant-numeric: tabular-nums;
}

._ComparisonMetric_1ga5u_179 {
  font-size: 16px;
}

._DonutChart_1ga5u_183 {
  outline: none;
  overflow: visible;
}
._DonutChart_1ga5u_183:focus, ._DonutChart_1ga5u_183:focus-visible {
  outline: none !important;
}

._Table_1h9pq_1 {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 6px;
  table-layout: fixed;
}

._ColorPreview_bcym0_1 {
  width: 12px;
}

._Name_bcym0_5 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 4px;
  padding-right: 20px;
}

._alignLeft_bcym0_13 {
  text-align: left;
}

._alignRight_bcym0_17 {
  text-align: right;
}

._Label_hgwz8_1 {
  text-align: center;
  padding-top: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
._Label_hgwz8_1 > span {
  padding: 0 4px;
  border-radius: "4px";
  border-radius: 4px;
}
._Label_hgwz8_1 > span:empty {
  display: none;
}

._YAxis_hgwz8_17 {
  overflow: visible;
}

._Row_vhmy9_144 {
  line-height: 16px;
  font-size: 11px;
  gap: 8px;
  display: flex;
  align-items: center;
}

._Value_vhmy9_152 {
  margin-left: auto;
  text-align: right;
  white-space: nowrap;
}

._Truncate_vhmy9_158 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

._Container_no9uw_1 {
  padding: 8px;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  border-radius: 5px;
  min-width: 180px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2), 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

._Title_tq23h_1 {
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
  overflow-wrap: break-word;
}

._AxisTitle_ahut2_1 {
  line-height: 16px;
  margin: 0;
}

._Series_1mcj1_1 {
  gap: 4px;
  display: flex;
  flex-direction: column;
}

._Container_1txl1_1 {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  list-style: none;
}

._IconContainer_hkbfs_1 {
  display: flex;
  align-items: center;
  justify-items: center;
  height: 12px;
  width: 20px;
}

._Container_1fw4x_1 {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  list-style: none;
}

._Icon_z9hgg_1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
}

._GroupCell_1h0pa_144 {
  opacity: var(--animation-opacity, 0);
  transform: scale(0);
  animation-name: _FadeInScale_1h0pa_1;
  animation-duration: 300ms;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
}

._GroupCellContainer_1h0pa_153 {
  transition: opacity 200ms ease-in-out;
  outline: 0;
}

._GroupCellContainerSelected_1h0pa_158:not([data-disabled=true]) {
  outline: 2px solid #2b62a9;
  outline-offset: -1px;
  border-radius: 4px;
}

@keyframes _FadeInScale_1h0pa_1 {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* stylelint-disable at-rule-no-unknown, property-no-unknown */

._Container_for9w_145 {
  container-type: inline-size;
  font-family: Inter, -apple-system, system-ui, "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

._FadeIn_for9w_156 {
  animation: _FadeInOpacity_for9w_1 0.5s ease-in-out forwards;
  animation-delay: 2s;
  animation-name: _FadeInOpacity_for9w_1;
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
}

@container (max-width: 399px) {
  ._Label_for9w_165 {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  ._GroupCell_for9w_171,
._ArrowShaft_for9w_172,
._ArrowHead_for9w_173,
._FadeIn_for9w_156,
._FadeInLabel_for9w_175 {
    animation: none;
    transition: none;
    opacity: 1;
    transform: scale(1);
  }

  ._ArrowShaft_for9w_172 {
    stroke-dasharray: none;
    stroke-dashoffset: 0;
  }
}
._ScreenReaderOnly_for9w_187 {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@keyframes _FadeInOpacity_for9w_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* stylelint-disable at-rule-no-unknown */

._TooltipActions_30ctf_145 {
  margin-top: 12px;
}

._TooltipAction_30ctf_145 {
  display: block;
  text-decoration: none;
  color: #2e2e36;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  margin: 0;
  padding: 6px 12px;
  text-align: center;
  border-radius: 8px;
  border: none;
  box-shadow: 0 0 0.5px 0.5px rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  background: white;
}

._TooltipAction_30ctf_145 span {
  box-sizing: border-box;
  display: block;
}

._TooltipAction_30ctf_145:hover {
  background: rgba(0, 0, 0, 0.025);
}

._GroupGoal_30ctf_174 {
  margin: 0;
  font-size: 11px;
  line-height: 1.2;
  color: var(--p-color-bg-surface-inverse);
  padding-right: 5px;
}

._TooltipTitle_30ctf_182 {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}

._TooltipDescription_30ctf_191,
._TooltipMetricInformation_30ctf_192 {
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #70707b;
  margin-bottom: 8px;
}

._TooltipMetricInformation_30ctf_192 {
  color: #2e2e36;
  font-weight: 500;
}

._TooltipGoal_30ctf_205 {
  display: flex;
  gap: 5px;
  padding: 4px;
  align-items: center;
  background: #eeeeef;
  margin-top: 12px;
  border-radius: 4px;
}

._Tooltip_30ctf_145 {
  font-size: 12px;
  font-family: Inter, -apple-system, system-ui, "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
  line-height: 1.3;
  padding: 12px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid lightgray;
}

._TooltipContainer_30ctf_226 {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 280px;
  outline: none;
}
@container (max-width: 399px) {
  ._TooltipContainer_30ctf_226 {
    display: none;
  }
}

._TooltipIcon_30ctf_240 {
  height: 13px;
  width: 20px;
}

/* stylelint-disable at-rule-no-unknown */
._Arrow_8uwn4_2 {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.4));
}

._ArrowShaft_8uwn4_6 {
  stroke-dasharray: 35;
  stroke-dashoffset: 35;
  animation: _Draw_8uwn4_1 0.2s ease-in-out forwards;
}
@container (max-width: 399px) {
  ._ArrowShaft_8uwn4_6 {
    display: none;
  }
}

._ArrowHead_8uwn4_17 {
  opacity: 0;
  animation: _FadeIn_8uwn4_1 0.2s ease-in-out forwards;
  animation-delay: 0.2s;
}
@container (max-width: 399px) {
  ._ArrowHead_8uwn4_17 {
    display: none;
  }
}

@keyframes _Draw_8uwn4_1 {
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes _FadeIn_8uwn4_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

._XAxisLabel_1gp7w_144 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #5e5e69;
  text-align: center;
}

._YAxisLabel_13oh4_144 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #5e5e69;
  text-align: center;
}

._Tooltip_i9bsr_1 {
  top: 0;
  left: 0;
  position: absolute;
  pointer-events: none;
  z-index: 520;
  max-width: 300px;
}

._Rows_16hlh_1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

._Row_16hlh_1 {
  font-size: 12px;
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: subgrid;
  color: #616161;
  align-items: center;
}

._Keys_16hlh_16 {
  display: flex;
  align-items: center;
  gap: 4px;
}

._Values_16hlh_22 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  font-weight: 600;
}
._Values_16hlh_22 strong {
  font-weight: 600;
  color: #1f2124;
}

._VisuallyHidden_at2zh_144 {
  position: absolute !important;
  top: 0;
  clip: rect(1px, 1px, 1px, 1px) !important;
  overflow: hidden !important;
  height: 1px !important;
  width: 1px !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0;
}

    #polaris_viz_tooltip_root [data-tooltip] {
      z-index: ${e.zIndex.tooltip};
    }
  `;export{i as StyledChartContainer,o as global};
